import React, {FC} from 'react';
import Button from '@mui/material/Button';
import {SxProps} from '@mui/material';

//TYPES
export type Props = {
  label: string,
  disabled?: boolean,
  onClick: () => void,
  sx: SxProps
};

const PrimaryButton: FC<Props> = ({label, disabled=false, onClick, sx}) => {
  return <Button variant="contained" onClick={onClick} disabled={disabled} sx={{...sx}}>
    {label}
  </Button>;
};
export default PrimaryButton;